import { useTranslation } from 'react-i18next';
import { Section } from '@/components/Section';

const PROHIBITED = [
  // 'cash',
  'drugs',
  'weapons',
  'explosives',
  'alcohol',
  'perishable',
  'animals',
  'illegal',
] as const;

export function RulesPage() {
  const { t } = useTranslation();
  return (
    <>
      <h1 className="mb-4 px-1 font-display text-2xl font-bold tracking-tight">
        {t('rules.title')}
      </h1>
      <Section title={t('rules.howTitle')}>
        <ol className="list-decimal space-y-2.5 px-5 py-4 pl-9 text-sm marker:font-bold marker:text-accent">
          <li>{t('rules.how1')}</li>
          <li>{t('rules.how2')}</li>
          <li>{t('rules.how3')}</li>
          <li>{t('rules.how4')}</li>
        </ol>
      </Section>
      <Section title={t('rules.prohibitedTitle')}>
        <ul className="space-y-2 px-5 py-4 text-sm">
          {PROHIBITED.map((k) => (
            <li key={k}>🚫 {t(`rules.prohibited.${k}`)}</li>
          ))}
        </ul>
      </Section>
      <p className="px-1 text-sm text-hint">{t('rules.responsibility')}</p>
    </>
  );
}
